"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useDataSources(query) {
  const { ...rest } = useElements("data-sources", query);
  return {
    dataSources: rest.items,
    ...rest
  };
}

export { useDataSources };
